import React, { useEffect, useState } from 'react';
import {
  Card, Typography, Upload, Button, Input, Table, Popconfirm, message, Space, Tag
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import AdminMenu from '../components/AdminMenu';
import { DownloadsAPI } from '../api/downloads';

const { Title } = Typography;

export default function AdminDownloadsPage() {
  const [list, setList] = useState([]);
  const [title, setTitle] = useState('');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchList = async () => {
    try {
      const data = await DownloadsAPI.listForAdmin();
      setList(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error(e);
      message.error('No se pudo cargar la lista de descargas');
    }
  };

  useEffect(() => { fetchList(); }, []);

  const uploadProps = {
    beforeUpload: (f) => { setFile(f); return false; },
    maxCount: 1,
  };

  const handleUpload = async () => {
    if (!file) return message.error('Selecciona un archivo');
    setLoading(true);
    try {
      await DownloadsAPI.upload({ file, title, visibility: 'ALL' }); // 👈 siempre ALL
      message.success('Archivo subido');
      setFile(null);
      setTitle('');
      fetchList();
    } catch (e) {
      console.error(e);
      message.error('Error al subir');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { title: 'Título', dataIndex: 'title', key: 'title' },
    {
      title: 'Tamaño',
      dataIndex: 'size_bytes',
      key: 'size',
      render: (b) => `${(Number(b) / 1024 / 1024).toFixed(1)} MB`,
    },
    {
      title: 'Visibilidad',
      dataIndex: 'visibility',
      key: 'vis',
      render: (v) => (v === 'ALL' ? <Tag color="green">Todos</Tag> : <Tag>{v}</Tag>)
    },
    {
      title: 'Acciones',
      key: 'act',
      render: (_, r) => (
        <Space>
          <a href={`/api/downloads/${r.id}/file`} target="_blank" rel="noreferrer">Descargar</a>
          <Popconfirm
            title="¿Eliminar?"
            okText="Sí"
            cancelText="No"
            onConfirm={async () => { await DownloadsAPI.remove(r.id); fetchList(); }}
          >
            <Button type="link" danger>Eliminar</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <AdminMenu />
      <div style={{ padding: '80px 20px 20px' }}>
        <Title level={3} style={{ color: '#fff' }}>Gestor de descargas</Title>

        <Card style={{ marginBottom: 16 }} title="Nueva descarga">
          <Input
            placeholder="Título (opcional)"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            style={{ marginBottom: 12 }}
          />
          <Upload {...uploadProps} accept="*/*">
            <Button icon={<UploadOutlined />} disabled={loading}>Seleccionar archivo</Button>
          </Upload>

          <div style={{ marginTop: 12 }}>
            <Button type="primary" onClick={handleUpload} loading={loading}>Subir</Button>
          </div>
        </Card>

        <Card title="Descargas publicadas">
          <Table rowKey="id" dataSource={list} columns={columns} pagination={{ pageSize: 8 }} />
        </Card>
      </div>
    </>
  );
}
